import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export function maxDigitLengthValidator(maxLength: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === "") {
      return null;
    }

    const length = value.toString().length;

    return length > maxLength
      ? {
          maxlength: {
            requiredLength: maxLength,
            actualLength: length,
          },
        }
      : null;
  };
}
